export const phoneLengthVerification = (
	watch: any,
	clearSpace: RegExp,
	phone: string,
) => {
	// console.log(`phone`, phone);

	return watch('phone')?.replace(clearSpace, '')?.replace(' ', '').length;
};
